import type { SkinDefinition } from '../index';
import { skinRegistry } from './registry.gen';

/**
 * 皮肤注册表入口（阶段 5：dl 降级为皮肤后启用）。
 *
 * 机制：
 * - registry.gen.ts 由 scripts/prepare-project.ts 按 project-config 的 skins 清单生成，
 *   仅入包皮肤被 import（未入包皮肤的代码不进包，隔离与主题同机制）；
 * - 指派由 project-config 的 skin 字段声明（useTheme.resolveSkinCode 读取），
 *   后续可改为后台 getInfo 的 mobileTheme 下发。
 *
 * 新增皮肤：
 * 1. 新建 src/themes/skins/{code}.ts（SkinDefinition：extends 基础主题 + colors/组件覆写/页面变体）；
 * 2. 组件变体放 src/themes/skins/{code}/components/{Key}.vue（签名与 base 一致）；
 *    页面变体放 src/themes/skins/{code}/{aspect}.vue（在定义文件 pages 方面声明）；
 * 3. project-config 的 skins 清单加入该 code（需指派的包同时声明 skin 字段）。
 */

/** 按 code 获取皮肤定义（未入包/未登记返回 undefined） */
export function getSkin(code: string): SkinDefinition | undefined {
  return skinRegistry[code];
}

export { skinRegistry };
